// extracted by css-extract-rspack-plugin
export default {"metricLink":"FT4Rm"};